import type { LearningLanguage, Verb } from '../types';
import { t } from '../i18n/translations';
import type { Language } from '../i18n/translations';
import { getVerbPracticeConfig } from '../utils/verbPractice';

interface SwipeCardProps {
  verb: Verb & { konj?: string };
  wordLang: 'pl' | 'ru';
  cardIndex: number;
  formVisibility: Record<string, boolean>;
  onFormToggle: (key: string, shown: boolean) => void;
  learningLanguage?: LearningLanguage;
  language?: Language;
}

export default function SwipeCard({
  verb,
  wordLang,
  formVisibility,
  onFormToggle,
  learningLanguage = 'pl',
  language = 'en',
}: SwipeCardProps) {
  const config = getVerbPracticeConfig(learningLanguage);
  const main = wordLang === 'ru' ? verb.ru : verb.inf;
  const sub = wordLang === 'ru' ? verb.inf : verb.ru;

  function renderFormCell(formKey: string, pronoun: string) {
    const key = formKey;
    const shown = formVisibility[key] !== false;
    return (
      <>
        <td className="pronoun">{pronoun}</td>
        <td>
          <div className="form-cell">
            <span className={`form-text${shown ? '' : ' hidden-form'}`}>
              {verb.forms[formKey]}
            </span>
            <label className="show-cb">
              <input
                type="checkbox"
                checked={shown}
                onChange={(e) => onFormToggle(key, e.target.checked)}
              />
            </label>
          </div>
        </td>
      </>
    );
  }

  return (
    <section className="card" role="group" aria-label={verb.inf}>
      <div className="cardHead">
        <div className="verb">
          {main}
          {verb.konj && <span className="konj-badge">{verb.konj}</span>}
        </div>
        <div className="gloss">{sub}</div>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th colSpan={2}>{t(language, 'kon.singular')}</th>
              <th colSpan={2}>{t(language, 'kon.plural')}</th>
            </tr>
          </thead>
          <tbody>
            {config.pronounRows.map(([sgKey, sgPronoun, plKey, plPronoun]) => (
              <tr key={sgKey}>
                {renderFormCell(sgKey, sgPronoun)}
                {renderFormCell(plKey, plPronoun)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
